<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';
import FormattedPrice from './FormattedPrice.vue';

const store = useStore();
const settings = window.measurementSelectorVariables.settings;

const shouldShowSpinner = computed(() => (store.getters.usePriceFromServer && store.getters.isRetrievingProperties) || store.getters.isRetrievingBulkPricing);
const totalPriceIncVat = computed(() => store.getters.getPriceIncVat);

</script>

<template>
	<Teleport to="#measurements-selector-price-desktop">
		<div class="price-group">
			<div class="kps-price">
				<i v-if="shouldShowSpinner" class="icon icon-spinner2"></i>
				<formatted-price v-else :price="totalPriceIncVat" dataTestID="product_side_bar_price_incl" />
			</div>
			<div class="m2-price">
				<i v-if="shouldShowSpinner" class="icon icon-spinner2"></i>
				<formatted-price v-else :price="settings.pricePerM2IncludingTax" dataTestID="product_side_bar_price_excl" /> / m²
			</div>
		</div>
	</Teleport>
	<Teleport to="#measurements-selector-price-mobile">
		<div class="price-group">
			<div class="kps-price">
				<i v-if="shouldShowSpinner" class="icon icon-spinner2"></i>
				<span v-else><formatted-price :price="totalPriceIncVat" dataTestID="product_side_bar_price_incl" /></span>
			</div>
			<div class="m2-price">
				<i v-if="shouldShowSpinner" class="icon icon-spinner2"></i>
				<formatted-price v-else :price="settings.pricePerM2IncludingTax" dataTestID="product_side_bar_price_excl" /> / m²
			</div>
		</div>
	</Teleport>
</template>
<style scoped lang="scss">

.kps-price {
	color: $headings-color-dark;
	@include font-size(28px, 34px);
	font-weight: 700;

	@media screen and (max-width: 768px) {
		@include font-size(14px, 18px);
	}
}

.price-group {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 16px;

	@media screen and (max-width: 768px) {
		gap: 8px;
	}
}

.m2-price {
	@include font-size(14px);
	border-radius: 4px;
	padding: 2px 6px;
	background-color: $grey-lightest;
	color: $grey-dark;
	font-weight: normal;

	@media screen and (max-width: 768px) {
		@include font-size(12px, 14px);
	}
}
</style>
